import { QUOTE, QUOTE_SALES } from '@constants/storageKeys';
import {
  OKTA_CACHE_STORAGE,
  OKTA_SHARED_TRANSACTION_STORAGE,
} from '@services/Auth/context';

const clearPartnerStorageItems = () => {
  localStorage.removeItem(OKTA_CACHE_STORAGE);
  localStorage.removeItem(OKTA_SHARED_TRANSACTION_STORAGE);
  localStorage.removeItem(QUOTE);
  localStorage.removeItem(QUOTE_SALES);
};

export { clearPartnerStorageItems };
